/**
 * Frontend mirror of the backend `FourDBS.Skoot.Core.Constants.SkootPermissions`
 * catalogue. Keep this in sync with
 * `src/DotNet/Backend/Skoot/Core/Constants/SkootPermissions.cs`.
 *
 * Use these names with `permissionGuard` route `data`, `MenuItem.permission`, and the
 * `*hasPermission` directive instead of hard-coded strings. Canvas-wide permissions
 * (Entity/Asset/Users/Accounts/...) live in `CanvasPermissions` in `@canvas/four-r-digital`.
 */
export const SkootPermissions = {
  DashboardView: 'Dashboard.View',
  ProductView: 'Product.View',
  ProductUpdate: 'Product.Update',
  SubscriptionView: 'Subscription.View',
  SubscriptionUpdate: 'Subscription.Update',
  OrderView: 'Order.View',
  OrderUpdate: 'Order.Update',
  PurchaseOrderView: 'PurchaseOrder.View',
  PurchaseOrderUpdate: 'PurchaseOrder.Update',
  AssetTrackingView: 'AssetTracking.View',
  AssetTrackingUpdate: 'AssetTracking.Update',
  VerificationView: 'Verification.View',
  VerificationUpdate: 'Verification.Update',
} as const;

export type SkootPermission =
  (typeof SkootPermissions)[keyof typeof SkootPermissions];
